import { IconActionsMoreHoriz, Text } from "@twinkltech/web-ui";

import { TableResource } from "@/states/unitTableReducer/unitTableReducer";

export const NewUnitCard = ({
  className,
  hideMenuButton,
  isDragging,
  resource,
  ...props
}: {
  hideMenuButton?: boolean;
  isDragging?: boolean;
  resource: TableResource;
} & Omit<React.ComponentProps<"div">, "resource">) => {
  return (
    <div
      aria-label={resource.name}
      className={[
        "min-h-[82px]",
        isDragging &&
          "card-dragging relative bg-neutral-150! before:content-[''] before:absolute before:bg-blue-500 before:rounded-lg before:w-1 before:left-0 before:top-[0.5rem] before:bottom-0 before:h-[calc(100%-1rem)] border-blue-500 border",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center py-2 px-1">
          <Text
            as="h3"
            className="line-clamp-2 whitespace-normal"
            id={`unit-title-${resource.id || resource.name}`}
            variant="sm-medium"
          >
            {resource.name}
          </Text>
        </div>
      </div>
      {/*
        Note: Some pokey-jiggery going on here. The icon is in the card and the button is overlayed on it. It's not great
        but we need the cross to be visible when dragging, and we can't render the action menu in the card (absolute positioning)
        because it would not be clickable due to the on-click dragging behavior.
      */}
      {!hideMenuButton && (
        <div
          className="flex flex-col justify-center border border-transparent rounded p-1"
          role="presentation"
        >
          <IconActionsMoreHoriz aria-hidden="true" />
        </div>
      )}
    </div>
  );
};
